
import {
  get,
  post,
  del
} from '@/http/request'
import {
  HOST
} from '@/http/config'


// 新增预约
export function addReservationForm(params) {
  return post(`${HOST}reservation-form/save`, params)
}
// 修改预约
export function updateReservationForm(params) {
  return post(`${HOST}reservation-form/updatefrom`, params)
}
//预约列表
export function getReservationForm(params) {
  return get(`${HOST}reservation-form/list`, params)
}
// 预约管理按照日历查看
export function calendarlist(params) {
  return get(`${HOST}reservation-form/calendarlist`, params)
}
//预约详情
export function ReservationFormDetial(params) {
  return get(`${HOST}reservation-form/get`, params)
}
// 删除预约
export function delReservationForm(params) {
  return del(`${HOST}reservation-form/delete`, params)
}

//用户选择预约科室
export function ReservationFormUserlist(params) {
  return get(`${HOST}reservation-form/userlist`, params)
}

//用户选择预约科室日期
export function ReservationFormUserappoint(params) {
  return get(`${HOST}reservation-sheet/userappoint`, params)
}

//用户选择预约科室日期
export function ReservationFormDatelist(params) {
  return get(`${HOST}reservation-form/datelist`, params)
}



// 管理员代课预约预约
export function sheetsave(params) {
  return post(`${HOST}reservation-sheet/sheetsave`, params)
}
// 修改/办理-预约单
export function updatesheet(params) {
  return post(`${HOST}reservation-sheet/updatesheet`, params)
}
//用户预约详情
export function getsheet(params) {
  return get(`${HOST}reservation-sheet/getsheet`, params)
}
//预约单列表
export function reservationSheetList(params) {
  return get(`${HOST}reservation-sheet/list`, params)
}
//我的预约单列表
export function reservationSheetUsermakelist(params) {
  return get(`${HOST}reservation-sheet/usermakelist`, params)
}



// WEBPACK FOOTER //
// ./src/views/BookingManagement/api/api.js